export default "__VITE_ASSET__CzOFWP1n__"